import React from "react";
import Seo from "../components/Seo";
import Footer from "../components/Footer";
import Hero from "../components/Heros/HeroBusiness";
import Cta from "../components/Cta";
import Feature from "../components/Features/FeatureDatabricks";

const Databricks = () => (
    <>
        <Seo
            title="Databricks 데이터 & AI 혁신"
            description="Databricks 공식 파트너. Lakehouse 아키텍처와 Unity Catalog 기반 데이터 거버넌스, 데이터 엔지니어링부터 BI·AI/ML까지 하나의 플랫폼으로 구축합니다."
            path="/databricks"
        />
        <Hero />
        <Feature />
        <Cta preset="contact" product="Databricks" />
        <Footer />
    </>
);

export default Databricks;
